module.exports = __webpack_public_path__ + "img/12.0e2c3526.png";